import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useI18n } from 'iomart-hooks';
// dayjs locales
import 'dayjs/locale/ru';
import 'dayjs/locale/en';
import 'dayjs/locale/de';
import 'dayjs/locale/fr';
import 'dayjs/locale/vi';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/ar';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

// dayjs uses 'zh-cn', our config uses 'cn'
const DAYJS_LOCALE_MAP: Record<string, string> = {
  cn: 'zh-cn',
};

export default function LocalizationProviderWithLang({ children }: Props) {
  const { currentLang } = useI18n();
  const adapterLocale = DAYJS_LOCALE_MAP[currentLang || ''] || currentLang || 'en';

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale}>
      {children}
    </LocalizationProvider>
  );
}
